<template>
  <div>
    <adv-cart-button
      :progress="progress"
      :comboProgress="comboProgress"
      :stock="stock"
      :quantity="quantity"
      v-html="buttonBuyText"
      v-on:btn-click="btnBuyClicked"
      v-on:btn-click-no-stock="btnBuyClickedNoStock"
      v-show="showAddToCart"
      :disabled="setDisabled"
    ></adv-cart-button>
  </div>
</template>

<script>
import { forEach, isEqual, uniqWith, some } from 'lodash'
import store from '../../vue/store'
import productMixin from './mixins/productMixins'
import onlineMixin from './mixins/onlineMixin'
import AdvCartButton from './AdvCartButton'
import cartButtonMixin from './mixins/cartButtonMixin'

export default {
  name: 'AdvButtonViewBuyCombo',
  mixins: [productMixin, onlineMixin, cartButtonMixin],
  props: {
    productIds: {
      type: Array
    },
    productId: {
      type: Number
    },
    comboProductStocks: {
      type: Object
    },
    showAddToCart: {
      type: Boolean,
      default: true
    }
  },
  components: {
    AdvCartButton
  },
  data () {
    return {
      version: '0.0.1',
      quickViewVisible: false,
      progress: false,
      comboProductIds: []
    }
  },
  computed: {
    setDisabled () {
      return !this.comboProductHasStock || !this.onlineStatus || this.comboProgress
    },
    comboProgress: {
      get () {
        return store.getters.getAddToCartComboClicked
      },
      set (value) { store.commit('setAddToCartComboClicked', value) }
    },
    stock () {
      return 1
    },
    comboProductHasStock () {
      return !some(this.comboProductStocks, { negative_stock: '0', stock: 0 })
    },
    quantity () {
      return store.getters.cartProductCodeQuantity(this.productIds[1])
    },
    price () {
      return this.productData.productFinalPrice
    },
    buttonBuyText () {
      if (!this.comboProductHasStock) {
        return this.t('product_status.unavailable.coming_soon')
      }
      return 'ΑΓΟΡΑΣΕ ΚΑΙ ΤΑ ΔΥΟ'
    }
  },
  methods: {
    btnBuyClicked () {
      this.progress = true
      const dispatchedActions = []
      store.dispatch('addToCartComboClicked', true)
      forEach(this.productIds, function (value) {
        dispatchedActions.push(store.dispatch('addToCartClicked', {
          productCodeId: value,
          quantity: store.getters.cartProductCodeQuantity(value)
        }))
      })
      Promise.all(dispatchedActions).then(dispatchedActionResults => {
        this.progress = false
        store.dispatch('addToCartComboClicked', false)
      })
    },
    btnBuyClickedNoStock () {
      // for clients that need click event without stock on button
    },
    allUniqueComboProductIds () {
      const allComboProductIds = []
      forEach(window.advAppData.comboProducts, (combo) => {
        forEach(combo, (product) => {
          allComboProductIds.push(Number(product.product_id))
        })
      })
      return uniqWith(allComboProductIds, isEqual)
    }
  },
  mounted () {
    this.comboProductIds = this.allUniqueComboProductIds()
  }
}
</script>
